document.addEventListener('DOMContentLoaded', function() {
  const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  const nav = document.querySelector('.nav');
  const body = document.body;
  let isMenuOpen = false;

  // 1. ЛОГИКА БУРГЕР-МЕНЮ
  if (mobileMenuBtn && nav) {
    mobileMenuBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      isMenuOpen = !isMenuOpen;

      if (isMenuOpen) {
        mobileMenuBtn.classList.add('active');
        nav.classList.add('active');
        body.classList.add('menu-open');
      } else {
        mobileMenuBtn.classList.remove('active');
        nav.classList.remove('active');
        body.classList.remove('menu-open');
      }
    });

    // Закрытие меню по клику вне его
    document.addEventListener('click', function(e) {
      if (isMenuOpen && !e.target.closest('.nav') && !e.target.closest('.mobile-menu-btn')) {
        isMenuOpen = false;
        mobileMenuBtn.classList.remove('active');
        nav.classList.remove('active');
        body.classList.remove('menu-open');
      }
    });
  }

 // 2. ПЛАВНЫЙ СКРОЛЛ (работает и с "#anchor", и с "http://site.com/#anchor")
document.querySelectorAll('a[href*="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const href = this.getAttribute('href');
    if (!href || href === '#') return;

    // Достаём только hash из ссылки
    const hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;

    const hash = href.substring(hashIndex);
    if (!hash || hash === '#') return;

    // Проверяем, что ссылка ведёт на текущий сайт (или относительная)
    const isSamePage = href.startsWith('#') || href.includes(window.location.hostname);
    if (!isSamePage) return;

    const target = document.querySelector(hash);
    if (target) {
      e.preventDefault();

      // Если меню открыто — закрываем и ждём, потом скроллим
      if (isMenuOpen && mobileMenuBtn && nav) {
        isMenuOpen = false;
        mobileMenuBtn.classList.remove('active');
        nav.classList.remove('active');
        body.classList.remove('menu-open');

        setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
      } else {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });
});
});
